'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgCheckboxUnselectedFilled16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none" }, props),
    React__namespace.createElement("path", { fill: props.fillColor, fillRule: "evenodd", clipRule: "evenodd", d: "M3.81078 14.3669C4.77686 14.4968 6.07198 14.5 8 14.5C9.92802 14.5 11.2231 14.4968 12.1892 14.3669C13.1121 14.2428 13.5071 14.0284 13.7678 13.7678C14.0284 13.5071 14.2428 13.1121 14.3669 12.1892C14.4968 11.2231 14.5 9.92802 14.5 8C14.5 6.07198 14.4968 4.77686 14.3669 3.81078C14.2428 2.88786 14.0284 2.49287 13.7678 2.23223C13.5071 1.9716 13.1121 1.75715 12.1892 1.63307C11.2231 1.50319 9.92802 1.5 8 1.5C6.07198 1.5 4.77686 1.50319 3.81078 1.63307C2.88786 1.75715 2.49287 1.9716 2.23223 2.23223C1.9716 2.49287 1.75715 2.88786 1.63307 3.81078C1.50319 4.77686 1.5 6.07198 1.5 8C1.5 9.92802 1.50319 11.2231 1.63307 12.1892C1.75715 13.1121 1.9716 13.5071 2.23223 13.7678C2.49287 14.0284 2.88786 14.2428 3.81078 14.3669ZM1.17157 1.17157C0 2.34315 0 4.22876 0 8C0 11.7712 0 13.6569 1.17157 14.8284C2.34315 16 4.22876 16 8 16C11.7712 16 13.6569 16 14.8284 14.8284C16 13.6569 16 11.7712 16 8C16 4.22876 16 2.34315 14.8284 1.17157C13.6569 0 11.7712 0 8 0C4.22876 0 2.34315 0 1.17157 1.17157Z", fillOpacity: 0.6 })));

exports.default = SvgCheckboxUnselectedFilled16;
//# sourceMappingURL=CheckboxUnselectedFilled16.js.map
